// extracted by mini-css-extract-plugin
module.exports = {"PreviewPage":"PreviewPage_PreviewPage__2cw0Q"};